import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

const Spinner = ({ color }) => {
  return (
    <CircularProgress
      color={color}
      style={{ width: "1.75rem", height: "1.75rem" }}
    />
  );
};

export default Spinner;
